import {
  ADMIN_CERTIFICATES_SETTINGS_KPI_OPTIONS,
  AdminCertificatesSettingsKpiFieldProps,
  getAdminCertificatesSettingsColumnLabel,
} from "../../../../models/admin-certificates-settings.models";

const AdminCertificatesSettingsKpiField = ({ value, saving, onChange }: AdminCertificatesSettingsKpiFieldProps) => (
  <label className="grid min-w-0 gap-1 text-xs font-semibold uppercase">
    <span className="truncate">{getAdminCertificatesSettingsColumnLabel("KPI_INCLUDED")}</span>
    <select
      value={value}
      disabled={saving}
      data-test="admin-certificates-settings-modal-field-KPI_INCLUDED"
      className="h-9 w-full min-w-0 border border-gray-300 bg-transparent px-3 text-sm font-normal normal-case outline-none focus:border-green disabled:opacity-50 dark:border-gray-700"
      onChange={(event) => onChange("KPI_INCLUDED", event.target.value)}
    >
      {ADMIN_CERTIFICATES_SETTINGS_KPI_OPTIONS.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </label>
);

export default AdminCertificatesSettingsKpiField;
